import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const SalesReturnShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Sales Return Section"
    sectionKey="Sales Return"
    backRoute="/sections/sales-return"
  />
);

export default SalesReturnShipmentRequest;
